


















import { Component, Vue, Prop } from "vue-property-decorator";
import { IOAuthProvider } from "../../types/config.model";
import { SELECTED_PROVIDERS } from "../../utils/auth";

@Component
export default class AuthProvider extends Vue {
  @Prop({ required: true, type: Object }) oauthProvider!: IOAuthProvider;

  SELECTED_PROVIDERS = SELECTED_PROVIDERS;

  get isProviderSelected(): boolean {
    return Object.keys(SELECTED_PROVIDERS).includes(this.oauthProvider.id);
  }
}
